import { render } from "./index.vue?vue&type=template&id=32e27567"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/cropper/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32e27567"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32e27567', __exports__)) {
    console.log('reload')
    api.reload('32e27567', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=32e27567", () => {
    console.log('re-render')
    api.rerender('32e27567', render)
  })

}


export default __exports__